import Keycloak from 'keycloak-js';

// Setup Keycloak instance as needed
// Pass initialization options as required or leave blank to load from 'keycloak.json'
const keycloak = new Keycloak({
  url: window.__env.KEYCLOAK_URL,
  realm: window.__env.AUTH_REALM,
  clientId: window.__env.AUTH_CLIENT_ID,
});

export default keycloak;